'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkResponse = checkResponse;
exports.callFetch = callFetch;

var _serviceHttpResponseError = require('./serviceHttpResponseError');

var _serviceHttpResponseError2 = _interopRequireDefault(_serviceHttpResponseError);

var _endpoints = require('./endpoints.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkResponse(serviceEndpoint) {
  return function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new _serviceHttpResponseError2.default('Error calling ' + serviceEndpoint + ' endpoint', res);
    }
  };
}

function callFetch(endpointKey, method, route, body, accessToken, env) {
  var endpointUrl = (env === 'int' ? _endpoints.int : _endpoints.prd)[endpointKey];

  var headers = new Headers({
    Accept: 'application/json',
    Authorization: 'Bearer ' + accessToken
  });

  method = method ? method.toUpperCase() : 'GET';
  if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
    headers.append('Content-Type', 'application/json');
  }

  var options = {
    method: method,
    mode: 'cors',
    headers: headers,
    body: body
  };

  var fullUrl = route ? endpointUrl + '/' + route : endpointUrl;
  return fetch(fullUrl, options).then(checkResponse(method + ' ' + fullUrl)).catch(function (error) {
    var name = error.name;
    var message = error.message || method + ' ' + fullUrl;
    var responseDetails = error.response ? '(' + error.response.status + ' ' + error.response.statusText + ')' : '';
    throw error;
  });
}
//# sourceMappingURL=serviceHelpers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/services/serviceHelpers.js
// module id = 137
// module chunks = 0